"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState } from "react";
import EmmaListSearch from "@/components/utils/input/emma/EmmaListSearch";
import type { AllowlistDescription, AllowlistResult } from "@/components/allowlist-tool/allowlist-tool.types";
import { useQuery } from "@tanstack/react-query";
import { distributionPlanApiFetch } from "@/services/distribution-plan-api";
import { AuthContext } from "@/components/auth/Auth";
import GroupCreateWalletsCount from "./GroupCreateWalletsCount";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
export default function CreateGroupWalletsEmma(t0) {
  const $ = _c(26);
  const {
    wallets,
    setWallets
  } = t0;
  const {
    requestAuth,
    connectedProfile
  } = useContext(AuthContext);
  const [selected, setSelected] = useState(null);
  const t1 = selected?.id;
  let t2;
  if ($[0] !== t1) {
    t2 = [QueryKey.EMMA_ALLOWLIST_RESULT, {
      allowlistId: t1
    }];
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== requestAuth || $[3] !== selected?.id) {
    t3 = async () => {
      await requestAuth();
      const {
        success
      } = await requestAuth();
      if (!success) {
        return [];
      }
      const endpoint = `/allowlists/${selected?.id}/results`;
      const {
        data
      } = await distributionPlanApiFetch(endpoint);
      return data ?? [];
    };
    $[2] = requestAuth;
    $[3] = selected?.id;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = !!connectedProfile?.handle && !!selected;
  let t5;
  if ($[5] !== t2 || $[6] !== t3 || $[7] !== t4) {
    t5 = {
      queryKey: t2,
      queryFn: t3,
      enabled: t4
    };
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const {
    data: emmaList,
    isFetching
  } = useQuery(t5);
  let t6;
  if ($[9] !== emmaList || $[10] !== setWallets) {
    t6 = () => setWallets(emmaList?.map(_temp) ?? null);
    $[9] = emmaList;
    $[10] = setWallets;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== emmaList) {
    t7 = [emmaList];
    $[12] = emmaList;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  useEffect(t6, t7);
  let t8;
  if ($[14] !== setWallets) {
    t8 = () => {
      setWallets(null);
      setSelected(null);
    };
    $[14] = setWallets;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const onWalletsRemove = t8;
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <p className="tw-mb-0 tw-text-base sm:tw-text-lg tw-font-semibold tw-text-iron-50">EMMA</p>;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const t10 = selected?.id ?? null;
  let t11;
  if ($[17] !== t10) {
    t11 = <div className="tw-mt-2 sm:tw-mt-3 tw-mb-3"><EmmaListSearch selectedId={t10} onSelect={setSelected} /></div>;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  const t12 = wallets?.length ?? null;
  let t13;
  if ($[19] !== isFetching || $[20] !== onWalletsRemove || $[21] !== t12) {
    t13 = <GroupCreateWalletsCount walletsCount={t12} loading={isFetching} removeWallets={onWalletsRemove} />;
    $[19] = isFetching;
    $[20] = onWalletsRemove;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t11 || $[24] !== t13) {
    t14 = <div className="tw-p-3 sm:tw-p-5 tw-bg-iron-950 tw-rounded-xl tw-shadow tw-border tw-border-solid tw-border-iron-800">{t9}{t11}{t13}</div>;
    $[23] = t11;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  return t14;
}
function _temp(item) {
  return item.wallet.toLowerCase();
}